import { render, staticRenderFns } from "./SearchLayout.vue?vue&type=template&id=204a1a1b&scoped=true"
import script from "./SearchLayout.vue?vue&type=script&lang=js"
export * from "./SearchLayout.vue?vue&type=script&lang=js"
import style0 from "./SearchLayout.vue?vue&type=style&index=0&id=204a1a1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a1a1b",
  null
  
)

export default component.exports